import { Scroll as Scroll_phosphor } from './Scroll.phosphor';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    default:
      return Scroll_phosphor;
  }
};

export const Scroll = IconRenderer();
